import * as types from '../constants/actionTypes';

let updateActions = [
  types.ANSWER_CORRELATION,
  types.ANSWER_DSA_USE_QUESTION,
  types.ANSWER_DSA_GOAL,
  types.ANSWER_DSA_VALUE_REALIZED,
  types.TOGGLE_BUSINESS_AREA,
  types.UPDATE_DSA,
  types.UPDATE_DSA_AREA_NOTE,
  types.UPDATE_DSA_CONFIGURED_ITEM,
  types.UPDATE_PEAK_BUFFER,
  // unused actions - pre-Account Details
  types.LINK_OPPORTUNITY,
  types.UNLINK_OPPORTUNITY
];

const initActions = {};
const successActions = {};

updateActions.forEach(action => {
  const successAction = action + '_SUCCESS';
  initActions[action] = action;
  successActions[successAction] = successAction;
});

export { initActions, successActions };



// WEBPACK FOOTER //
// ./src/actions/savingUpdatesTextActions.js